import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Ticket.css";
import insta from "../img/insta.png";
import facebook from "../img/facebook.png";
import mail from "../img/mail.png";

function Ticket() {
  const location = useLocation();
  const navigate = useNavigate();
  // Try to get ticket from state or query param
  const ticket = location.state?.ticket || new URLSearchParams(location.search).get("ticket") || "XXXXXX";

  const contactNumbers = [
    "+91 7896074971",
    "+91 8453412487",
    "+91 6003019117",
    // Add more numbers as needed
  ];

  // Pick a random number each render
  const randomContact = contactNumbers[Math.floor(Math.random() * contactNumbers.length)];

  return (
    <div className="ticket-bg">
      <div className="ticket-container">
        <div className="ticket-checkmark">
          <svg width="90" height="90" viewBox="0 0 90 90"><circle cx="45" cy="45" r="45" fill="#6fcf3f"/><polyline points="28,48 41,61 62,36" fill="none" stroke="#fff" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <h2 className="ticket-congrats">CONGRATULATIONS YOUR REGISTRATION HAS BEEN DONE</h2>
        <div className="ticket-staff">Staff will reach out in 24-48hrs</div>
        <div className="ticket-code-box">{ticket}</div>
        <div className="ticket-note">Please note the ticket down as it will be required for payment
          <br/>
          You can contact us on our{" "}
          <a className="ticket-link" href="https://www.instagram.com/unisfera_official/" target="_blank" rel="noopener noreferrer">
            instagram
          </a>
          {" "}or Text us at <span className="ticket-link">{randomContact}</span>
        </div>
        <div className="ticket-learn">
          Want to learn about us?<br/>
          You can do so by clicking <span className="ticket-link" onClick={()=>navigate("/about")}>here</span>
        </div>
      </div>
      <div className="information">
        <div className="links">
            <a href="https://www.instagram.com/unisfera_mun/"><img src={insta} alt="insta" className="image insta"></img></a>
            <a href="https://www.facebook.com/"><img src={facebook} alt="facebook" className="image facebook"></img></a>
            <a href="mailto:unisferamodelunitednations@gmail.com"><img src={mail} alt="mail" className="image mail"></img></a>     
          </div>
        <div className="copyright">© 2025 Unisfera, Inc. All Rights Reserved.</div>
      </div>
    </div>
  );
}

export default Ticket; 